import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from 'app/commonComponents/atoms/button';
import { MeasurementSystem } from './constants';

export const InchesButton = ({ onClick, isDisabled, isSelected }) => (
  <Button
    buttonClassName={`interactive-size-guide__btn ${isSelected ? 'interactive-size-guide__btn--selected' : ''}`}
    isDisabled={isDisabled}
    buttonOnClick={onClick}
    buttonText={<FormattedMessage id={MeasurementSystem.imperial.unit} />}
  />
);

export const CentimetersButton = ({ onClick, isDisabled, isSelected }) => (
  <Button
    buttonClassName={`interactive-size-guide__btn ${isSelected ? 'interactive-size-guide__btn--selected' : ''}`}
    isDisabled={isDisabled}
    buttonOnClick={onClick}
    buttonText={<FormattedMessage id={MeasurementSystem.metric.unit} />}
  />
);
